import React from "react";
import ActualSourceFieldComponent from "../../containers/Mapper/MapAndTransform/ActualSourceFieldComponent";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Droppable } from "react-beautiful-dnd";
import { useFormikContext } from "formik";

const DataModelChildGroupComponent = (props) => {
  const {
    characters,
    setCharacters,
    handleOnDragEnd,
    clickToSelect,
    fieldArrayName,
    headerValueKey,
  } = props;
  const { values, setFieldValue } = useFormikContext();

  return (
    <div className="source-field">
      <Droppable droppableId="source fields">
        {(provided) => (
          <ul
            style={{ listStyle: "none", paddingLeft: "0px" }}
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {characters.map((item, index) => {
              if (item.isCollection) {
                if (headerValueKey == "Value")
                  return (
                    <div>
                      <div className="group-name">
                        <span
                          className="fieldText"
                          style={{ marginLeft: "2rem", paddingTop: "0.5rem" }}
                        >
                          {item.groupName}
                        </span>
                      </div>

                      <div className="childArrow">
                        {item.childObjectMaps?.map((subHead, ind) => {
                          return (
                            <div className="listChildArrow">
                              {/* <i
                                style={{
                                  borderBottom: "1px dashed #828282",
                                  display: "flex",
                                  paddingLeft: "16px",
                                  paddingTop: "35px",
                                  height: "0",
                                }}
                              >*/}
                              <i
                                style={{
                                  position: "absolute",
                                  marginLeft: "-20px",
                                  marginTop: "21px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faChevronRight}
                                  style={{ color: "#828282" }}
                                />
                              </i>
                              {/* </i> */}
                              <div
                                style={{
                                  width: "120%",
                                  marginLeft: "-10px",
                                  justifyContent: "space-between",
                                }}
                                onClick={() => {
                                  if (clickToSelect)
                                    handleOnDragEnd(
                                      {
                                        draggableId: subHead.tId,
                                        mode: "FLUID",
                                        reason: "DROP",
                                        type: "DEFAULT",
                                        destination: {
                                          droppableId: fieldArrayName,
                                          index: index,
                                        },
                                        source: {
                                          index: index,
                                          droppableId: "source container",
                                        },
                                      },
                                      values,
                                      setFieldValue
                                    );
                                }}
                              >
                                <ActualSourceFieldComponent
                                  item={subHead}
                                  index={ind}
                                  characters={characters}
                                  setCharacters={setCharacters}
                                  isOutput={true}
                                  clickToSelect={clickToSelect}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                else return null;
              } else
                return (
                  <div
                    onClick={() => {
                      if (clickToSelect)
                        handleOnDragEnd(
                          {
                            draggableId: item.tId,
                            mode: "FLUID",
                            reason: "DROP",
                            type: "DEFAULT",
                            destination: {
                              droppableId: fieldArrayName,
                              index: index,
                            },
                            source: {
                              index: index,
                              droppableId: "source container",
                            },
                          },
                          values,
                          setFieldValue
                        );
                    }}
                  >
                    <ActualSourceFieldComponent
                      item={item}
                      index={index}
                      characters={characters}
                      setCharacters={setCharacters}
                      isOutput={true}
                      clickToSelect={clickToSelect}
                    />
                  </div>
                );
            })}
          </ul>
        )}
      </Droppable>
    </div>
  );
};

export default DataModelChildGroupComponent;
